import React, { useState } from 'react';
import jwt_decode from 'jwt-decode';
import { BrowserRouter as Router } from 'react-router-dom';

// Layouts 
import Login from './layout/Login';
import Dashboard from './layout/Dashboard';

function App() {
  const [token, setToken] = useState();
  const [userData, setUserData] = useState();

  // Check if there is a token in sessionStorage
  const authToken = sessionStorage.getItem('auth-token');
  if (authToken && !token) {
    const decodedData = jwt_decode(authToken);
    setUserData({
      id: decodedData.id,
      name: decodedData.name,
      lastname: decodedData.lastname,
    });
    setToken(authToken);
  }

  // Update User Data
  const updateUserData = (token) => {
    const decodedData = jwt_decode(token);
    setUserData({
      id: decodedData.id,
      name: decodedData.name,
      lastname: decodedData.lastname,
    });
    setToken(authToken);
  }

  // Logout Handling
  const logoutHandler = () => {
    // Remove the session storage
    sessionStorage.removeItem('auth-token');
    // Remove user data
    setUserData(null);
    // Remove the token
    setToken(null);
  };

  return (
    <Router>
      {token ? <Dashboard 
                  userData={userData}
                  updateUserData={updateUserData}
                  logoutHandler={logoutHandler} /> : 
                <Login 
                  setToken={setToken} 
                  setUserData={setUserData} />}
    </Router>
  );
}

export default App;
